export default "__VITE_ASSET__D7in__FI__"